import {Injectable} from '@angular/core';
import {DiagramJsonHandlerService} from '../../../diagram-data/diagram-json-handler.service';
import {
  isActivity,
  isConnector,
  isFlowline,
  isImage,
  isInteraction,
  isSticker,
  isTerminator,
  isText
} from '../../helpers/shapes-detectors.util';

declare const mxCell: any;

@Injectable()
export class MxCellExtend {
  constructor(jsonSvc: DiagramJsonHandlerService) {
    mxCell.prototype.getJson = function () {
      const currentJson = jsonSvc.get();

      if (isActivity(this) && currentJson.activities) {
        return currentJson.activities.find(act => Number(act.mxKey) === Number(this.id));
      }

      if (isConnector(this) && currentJson.flowlines) {
        return currentJson.flowlines.reduce((acc, curr) => {
          if (curr.connector && Number(curr.connector.mxKey) === Number(this.id)) {
            const json = curr.connector;

            json.flowlineMxKey = Number(curr.mxKey);

            return json;
          }

          return acc;
        }, {});
      }

      if (isTerminator(this) && currentJson.flowlines) {
        return currentJson.flowlines.reduce((acc, curr) => {
          if (curr.terminator && Number(curr.terminator.mxKey) === Number(this.id)) {
            const json = curr.terminator;

            json.flowlineMxKey = Number(curr.mxKey);

            return json;
          }

          return acc;
        }, {});
      }

      if (isText(this) && currentJson.texts) {
        return currentJson.texts.find(text => Number(text.mxKey) === Number(this.id));
      }

      if (isSticker(this) && currentJson.notes) {
        return currentJson.notes.find(elem => Number(elem.mxKey) === Number(this.id));
      }

      if (isImage(this) && currentJson.images) {
        return currentJson.images.find(elem => Number(elem.mxKey) === Number(this.id));
      }

      if (isFlowline(this) && currentJson.flowlines) {
        return currentJson.flowlines.find(elem => Number(elem.mxKey) === Number(this.id));
      }

      if (isInteraction(this) && currentJson.interactions) {
        const flowlineMxKey = String(this.id).split('-')[0];

        return currentJson.interactions.find(
          elem => Number(elem.flowlineMxKey) === Number(flowlineMxKey)
        );
      }

      return {};
    };
  }
}
